module.exports = __webpack_public_path__ + "img/chieti-pescara.95940b7f.png";